import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Trophy, Flame, Sparkles, Compass, BookOpen, FileSignature, Lock } from "lucide-react";

const ICONS = { Trophy, Flame, Sparkles, Compass, BookOpen, FileSignature };
const COLOR_MAP = {
  amber: "bg-amber-100 text-amber-700 border-amber-200",
  indigo: "bg-indigo-100 text-indigo-700 border-indigo-200",
  emerald: "bg-emerald-100 text-emerald-700 border-emerald-200",
  rose: "bg-rose-100 text-rose-700 border-rose-200",
  orange: "bg-orange-100 text-orange-700 border-orange-200",
  violet: "bg-violet-100 text-violet-700 border-violet-200",
};

export default function Badges() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/gamification").then(r => setData(r.data));
  }, []);

  if (!data) return <div className="text-slate-500">Loading…</div>;

  return (
    <div className="space-y-8">
      <div>
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-2xl bg-amber-100 text-amber-700 grid place-items-center"><Trophy size={20}/></div>
          <h1 className="text-3xl font-bold" style={{fontFamily:'Outfit'}}>Badges</h1>
        </div>
        <p className="text-slate-600">
          You've earned <strong data-testid="badge-summary">{data.earned_count}</strong> of {data.total_badges} badges.
          Current streak: <strong>{data.streak}</strong> day{data.streak===1?"":"s"} 🔥
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {data.badges.map(b => {
          const Icon = ICONS[b.icon] || Trophy;
          const color = COLOR_MAP[b.color] || COLOR_MAP.indigo;
          return (
            <div key={b.id} data-testid={`badge-card-${b.id}`}
              className={`tactile-card p-6 ${b.earned ? '' : 'opacity-60 grayscale'}`}>
              <div className={`w-14 h-14 rounded-2xl border-2 ${color} grid place-items-center mb-4`}>
                {b.earned ? <Icon size={26}/> : <Lock size={22}/>}
              </div>
              <div className="flex items-center gap-2 mb-1">
                <h3 className="text-xl font-bold" style={{fontFamily:'Outfit'}}>{b.name}</h3>
                {b.earned && (
                  <span className="rounded-full bg-emerald-100 text-emerald-800 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider">Earned</span>
                )}
              </div>
              <p className="text-slate-600 text-sm">{b.desc}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
